import React, { useCallback } from 'react';
import { Upload, Loader2 } from 'lucide-react';

const FileUploader = ({ source, onFileUpload, isLoading }) => {
  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      const file = e.dataTransfer.files[0];
      if (file) {
        onFileUpload(file);
      }
    },
    [onFileUpload]
  );

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleFileChange = useCallback(
    (e) => {
      const file = e.target.files?.[0];
      if (file) {
        onFileUpload(file);
      }
    },
    [onFileUpload]
  );

  if (!source) return null;

  return (
    <div
      className={`
        border-2 border-dashed rounded-lg p-8 text-center 
        ${isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:border-blue-500'} 
        transition-colors
      `}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
    >
      <div className="flex flex-col items-center gap-4">
        {isLoading ? (
          <Loader2 className="w-12 h-12 text-blue-500 animate-spin" />
        ) : (
          <Upload className="w-12 h-12 text-gray-400" />
        )}
        
        <div className="text-gray-600 dark:text-gray-300">
          <p className="font-medium">
            {source.referenceFile} dosyanızı buraya sürükleyin
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-400">veya</p>
        </div>

        <label className={`
          cursor-pointer px-4 py-2 rounded
          ${isLoading 
            ? 'bg-gray-400 cursor-not-allowed' 
            : 'bg-blue-500 hover:bg-blue-600'
          }
          text-white transition-colors
        `}>
          Dosya Seçin
          <input
            type="file"
            className="hidden"
            onChange={handleFileChange}
            accept={source.acceptedFormats}
            disabled={isLoading}
          />
        </label>

        <p className="text-sm text-gray-500 dark:text-gray-400">
          {source.acceptedFormats} formatları desteklenir
        </p>
      </div>
    </div>
  );
};

export default FileUploader;